/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import NumberFieldConfigured from "../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type IncomeAssetsProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function IncomeAssets({ submitProps, product }: IncomeAssetsProps) {
  const { values, handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Einnahmen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type={"radio"}
                name={"hasIncomeChildAllowance"}
                question={"Erhalten Sie Kindergeld oder Kinderzuschläge?"}
                modalContent={<p>Kindergeld erhalten Sie von der Familienkasse. Kinderzuschläge sind Zuschüsse, die sie vom Arbeitgeber bekommen. </p>}
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasIncomeChildAllowance === "yes" && (
              <>
                <Grid sx={wizardStyle.gridTopSpaced} size={12}>
                  <FormLegend>
                    Bitte geben Sie hier den monatlichen <strong>Brutto</strong>betrag an.
                  </FormLegend>
                </Grid>
                <NumberFieldConfigured caseData={product} fieldPath={"incomeChildAllowanceAmount"} fieldType={"money"} numberType={"float"} required />
              </>
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
